module.exports = __webpack_public_path__ + "static/img/版头设计-平面合成类版头.7896c5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10002/版头设计-平面合成类版头.png
// module id = FYXI
// module chunks = 1